import { absMoney, dueLabel, dueTone, money } from "./accountEditorUi";

const MODULE_CARDS = [
  {
    id: "admission",
    label: "Admission",
    hint: "Terms, commission and bonus",
    next: "Manage terms",
  },
  {
    id: "visa",
    label: "Visa",
    hint: "Client payments",
    next: "Record payments",
  },
  {
    id: "insurance",
    label: "Insurance",
    hint: "Payments and monthly commission",
    next: "Record commission",
  },
  {
    id: "skill",
    label: "Skill Assessment",
    hint: "Client payments",
    next: "Record payments",
  },
  {
    id: "rpl",
    label: "RPL",
    hint: "Client payments",
    next: "Record payments",
  },
  {
    id: "others",
    label: "Others",
    hint: "Custom charges",
    next: "Add an entry",
  },
];

const AccountOverviewPanel = ({
  tabCounts = {},
  moduleTotals = {},
  pendingByModule = {},
  onSelectTab,
}) => (
  <div className="space-y-3">
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-2.5">
      {MODULE_CARDS.map((mod) => {
        const count = tabCounts[mod.id] || 0;
        const totals = moduleTotals[mod.id] || {};
        const pending = pendingByModule[mod.id] || 0;
        const due = Number(totals.due) || 0;
        const empty = count === 0;
        if (empty) return null;
        return (
          <button
            key={mod.id}
            type="button"
            onClick={() => onSelectTab(mod.id)}
            className={`text-left rounded-xl border px-3.5 py-3 transition-all bg-app-surface hover:border-primary/50 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 ${
              pending > 0
                ? "border-amber-300 bg-amber-50/40"
                : empty
                ? "border-dashed border-app-border"
                : "border-app-border"
            }`}
          >
            <div className="flex items-start justify-between gap-2">
              <div className="min-w-0">
                <p className="text-lg underline font-semibold text-app-text m-0">{mod.label}</p>
              </div>
              <span className="rounded-full bg-app-surface-muted px-2 py-0.5 text-md font-bold text-app-text-secondary shrink-0">
                {count}
              </span>
            </div>
            {empty ? (
              <p className="text-md text-app-text-muted m-0 mt-2">None yet · {mod.next}</p>
            ) : (
              <div className="mt-2.5 space-y-1.5">
                <div className="flex flex-wrap items-center justify-between gap-x-3 gap-y-1 text-md">
                  <span className="text-app-text-muted">
                    {dueLabel(due)}{" "}
                    <span
                      className={`font-semibold ${
                        dueTone(due) === "warn" ? "text-amber-700" : "text-app-text"
                      }`}
                    >
                      {absMoney(due)}
                    </span>
                  </span>
                  <span className="text-app-text-muted">
                    Paid <span className="font-semibold text-app-text">{money(totals.paid)}</span>
                  </span>
                </div>
                {mod.id === "insurance" && Number(totals.commission) > 0 && (
                  <p className="text-md text-app-text-muted m-0">
                    Commission{" "}
                    <span className="font-semibold text-app-text">{money(totals.commission)}</span>
                  </p>
                )}
              </div>
            )}
            {pending > 0 && (
              <p className="text-md font-semibold text-amber-700 m-0 mt-1.5">
                {pending} pending verification{pending === 1 ? "" : "s"}
              </p>
            )}
          </button>
        );
      })}
    </div>
  </div>
);

export default AccountOverviewPanel;
